module.exports = __webpack_public_path__ + "static/media/publishing_image5.6c9ab0c8.webp";